import { TableCell, TableHead, TableRow } from "@material-ui/core";
import moment from "moment-timezone";
import React from "react";
import { Button, Confirm, CreateButton, Datagrid, EditButton, FormDataConsumer, RecordContextProvider, useNotify } from "react-admin";
import { useForm } from "react-final-form";
import { PopupboxManager } from "react-popupbox";
import { AddPaidIconDialog } from "./paid-icon-dialog";

const addPaidIconButtonOnClick = (form) => {
  const handleSave = (value) => {
    const oldData = form.getState().values.icons ?? [];
    const newData = [...oldData]; //Clone

    newData.push(value);

    form.change("icons", newData);
  };

  const type = form.getState().values.type;

  PopupboxManager.open({
    content: <AddPaidIconDialog key={moment().unix()} form={form} type={type} handleSave={handleSave} />,
    config: {
      style: { width: "80%", height: "80%" },
      overlayClose: false,
      escClose: false,
      content: {
        style: {
          overflowY: "scroll",
        },
      },
    },
  });
};

// Edit popup
const editPaidIconButtonOnClick = (form, item, index) => {
  const handleSave = (value) => {
    const oldData = form.getState().values.icons ?? [];
    const newData = [...oldData]; //Clone

    newData[index] = value;

    form.change("icons", newData);
  };

  const type = form.getState().values.type;

  PopupboxManager.open({
    content: <AddPaidIconDialog key={moment().unix()} form={form} type={type} item={item} index={index} handleSave={handleSave} />,
    config: {
      style: { width: "80%", height: "80%" },
      overlayClose: false,
      escClose: false,
      content: {
        style: {
          overflowY: "scroll",
        },
      },
    },
  });
};

const DatagridHeader = ({ readonly }) => (
  <TableHead>
    <TableRow>
      <TableCell style={{}}>Id</TableCell>
      <TableCell style={{}}>Paid Icon name</TableCell>
      <TableCell style={{}}>Before purchase icon*</TableCell>
      <TableCell style={{}}>After purchase icon*</TableCell>
      <TableCell style={{}}>Smart TV Animation*</TableCell>
      <TableCell style={{}}>Mobile Animation*</TableCell>
      {!readonly && <TableCell style={{}}></TableCell>} {/* Edit button */}
      {!readonly && <TableCell style={{}}></TableCell>} {/* Delete button */}
    </TableRow>
  </TableHead>
);

const MyDatagridBody = ({ items, readonly, ...props }) => {
  return items.map((item, index) => {
    //Skip deleted items
    if (item.delete) {
      return <></>;
    }

    return <MyDatagridRow item={item} pos={index} readonly={readonly} {...props} />;
  });
};

const CustomDeleteButton = ({ item, pos }) => {
  const [showConfirm, setShowConfirm] = React.useState(false);
  const notify = useNotify();
  const form = useForm();

  return (
    <React.Fragment>
      <Button
        label="Delete"
        style={{ color: "red" }}
        onClick={() => {
          setShowConfirm(true);
        }}
      />
      <Confirm
        isOpen={showConfirm}
        title="Delete this icon?"
        content={
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 12 }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: 12, flexWrap: "wrap" }}>
              <img src={form.getState().values.icons[pos].purchase_image_info?.locked_icon} style={{ height: "100px", width: "100px" }} />
              <img src={form.getState().values.icons[pos].purchase_image_info?.unlocked_icon} style={{ height: "100px", width: "100px" }} />
            </div>
            <span>Are you sure you want to delete this item?</span>
          </div>
        }
        onConfirm={async () => {
          try {
            const icons = form.getState().values.icons ?? [];
            const newIcons = [...icons]; //Clone

            if (item.id) {
              //set delete=true if it's from server
              newIcons[pos].delete = true;
            } else {
              //Remove from list if it's newly added
              newIcons.splice(pos, 1); //Remove 1 item at pos
            }
            form.change("icons", newIcons);
          } catch (error) {
            notify(error.message.toString(), "warning");
          }

          setShowConfirm(false);
        }}
        onClose={() => {
          setShowConfirm(false);
        }}
      />
    </React.Fragment>
  );
};

const MyDatagridRow = ({ item, pos, readonly }) => {
  const form = useForm();

  const hideActionButtons = readonly || (item.is_used ?? false);

  return (
    <RecordContextProvider value={item}>
      <TableRow>
        <TableCell style={{ overflowWrap: "break-word" }}>{item.id}</TableCell>
        <TableCell style={{ overflowWrap: "break-word" }}>{item.purchase_image_info?.name}</TableCell>
        <TableCell style={{ overflowWrap: "break-word" }}>
          <img src={item.purchase_image_info?.locked_icon} style={{ height: "100px", width: "100px" }} />
        </TableCell>
        <TableCell style={{ overflowWrap: "break-word" }}>
          <img src={item.purchase_image_info?.unlocked_icon} style={{ height: "100px", width: "100px" }} />
        </TableCell>
        <TableCell style={{ overflowWrap: "break-word" }}>
          <a href={item.purchase_image_info?.animation_icon_tv} target="_blank" rel="noopener noreferrer">
            <span>{item.purchase_image_info?.animation_icon_tv_file_name}</span>
          </a>
        </TableCell>
        <TableCell style={{ overflowWrap: "break-word" }}>
          <a href={item.purchase_image_info?.animation_icon_mobile} target="_blank" rel="noopener noreferrer">
            <span>{item.purchase_image_info?.animation_icon_mobile_file_name}</span>
          </a>
        </TableCell>
        {!hideActionButtons && (
          <TableCell>
            <EditButton
              onClick={(e) => {
                e.preventDefault();

                editPaidIconButtonOnClick(form, item, pos);
              }}
              label="Edit"
            />
          </TableCell>
        )}
        {!hideActionButtons && (
          <TableCell style={{ overflowWrap: "break-word" }}>
            <CustomDeleteButton item={item} pos={pos} />
          </TableCell>
        )}
      </TableRow>
    </RecordContextProvider>
  );
};

export const IMPaidIconList = ({ readonly = false }) => {
  const form = useForm();

  return (
    <>
      {!readonly && (
        <CreateButton
          label="Add"
          onClick={(e) => {
            e.preventDefault();
            addPaidIconButtonOnClick(form);
          }}
        />
      )}
      <FormDataConsumer>
        {({ formData }) => {
          const rows = formData.icons;

          return (
            <Datagrid
              // style={{ tableLayout: "fixed" }}
              header={<DatagridHeader readonly={readonly} />}
              body={<MyDatagridBody items={rows ?? []} readonly={readonly} />}
            />
          );
        }}
      </FormDataConsumer>
    </>
  );
};
